import API from '../apiCreate'
import type { EmptyResponse } from '../types/base.types'
import type {
  CrmCreateFunnelResponse,
  CrmFunnelsAvailableForLeadResponse,
  CrmFunnelsIndexResponse,
  CrmFunnelStatusesResponse,
  RequestCreateFunnelStatus,
  RequestUpdateFunnelStatus,
} from '../types/crm/crmFunnels.types'
import type { CrmApiRequestConfig } from './crmApiRequestConfig'

/** Воронки CRM: `/v1/crm-funnel/*`. */
export const crmFunnelApi = {
  getAllFunnels: () => API.get<CrmFunnelsIndexResponse>('crm-funnel/index'),
  getAvailableForLead: (params: { lead_id: number }) =>
    API.get<CrmFunnelsAvailableForLeadResponse>(
      `crm-funnel/available-for-lead?lead_id=${params.lead_id}`,
    ),

  createFunnel: (name: string) =>
    API.post<CrmCreateFunnelResponse>('crm-funnel/create', { name }),
  updateFunnel: (id: number, name: string) =>
    API.patch<EmptyResponse>(`crm-funnel/update?id=${id}`, { name }),
  deleteFunnelWithPassword: (id: number, confirmation: string) =>
    API.delete<EmptyResponse>(`crm-funnel/delete?id=${id}`, {
      data: { confirmation },
    }),
  sortFunnels: (data: { items: number[] }) =>
    API.patch<EmptyResponse>('crm-funnel/sorting', data),

  statuses: {
    getStatuses: ({ funnel_id }: { funnel_id: number }) =>
      API.get<CrmFunnelStatusesResponse>(
        `crm-funnel/statuses?funnelId=${funnel_id}`,
      ),
    createStatus: ({
      funnel_id,
      data,
      config,
    }: {
      funnel_id: number
      data: RequestCreateFunnelStatus
      config?: CrmApiRequestConfig
    }) =>
      API.post<EmptyResponse>(
        `crm-funnel/create-status?funnelId=${funnel_id}`,
        data,
        config as any,
      ),
    deleteStatus: ({ id }: { id: number }) =>
      API.delete<EmptyResponse>(`crm-funnel/delete-status?statusId=${id}`),
    updateStatus: ({
      id,
      data,
      config,
    }: {
      id: number
      data: RequestUpdateFunnelStatus
      config?: CrmApiRequestConfig
    }) =>
      API.patch<EmptyResponse>(
        `crm-funnel/update-status?statusId=${id}`,
        data,
        config as any,
      ),
  },
}
